import { render, staticRenderFns } from "./Exposicao.vue?vue&type=template&id=da8aaaa4&"
import script from "./Exposicao.vue?vue&type=script&lang=js&"
export * from "./Exposicao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports